import { createMemoryHistory, createBrowserHistory } from 'history';

export const history =
  typeof window === 'undefined'
    ? createMemoryHistory({
        initialEntries: ['/'],
      })
    : createBrowserHistory();
